import Link from "next/link";
import React, { useContext, useState, useTransition } from "react";
import helper from "../../lib/helper";
import offersModel from "../../models/offers.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import moment from "moment/moment";
import { Button, Dropdown, Modal, ToggleButton } from "react-bootstrap";
const Page = function () {
    const [showLoader, setShowLoader] = useState(false);

    const router = useRouter();
    const queryParams = router.query;
    const { data: offersData, mutate: reloadoffersData, isLoading } = useSWR(
        queryParams || null,
        () => offersModel.list(queryParams),
        config.swrConfig
    );

    const columns =  [
        {
            Header: "Title",
            accessor: "title",
            className: "col"
        },
        {
            Header: "Discount-code",
            accessor: "code",
            className: "col"
        },
        {
            Header: "Minimum-value",
            accessor: "minimum_amount",
            className: "col"
        },
        {
            Header: "Discount-type",
            accessor: "discount_type",
            className: "col"
        },
        {
            Header: "Discount-value",
            accessor: "discount_value",
            className: "col"
        },
         {
            Header: "Date",
            id: "created_at",
            Cell: ({ row }) => (
                <>
                    <div>
                    {helper.date.format(row.original.created_at)}
                    </div>
                </>
            )
            },
        {
            className: "col-auto text-end",
            Header: "Actions",
            id: "action",
            Cell: ({ row }) => (
                <div >

                        <Dropdown className="btn-group btn-group-sm">
                            <Link
                                className="btn btn-outline-primary"
                                href={`/offers/${row.original.id}`}
                            >
                                <i className="bi bi-eye"></i>
                            </Link>
                            <Dropdown.Toggle size="sm" variant="outline-primary">
                                <i className="bi bi-three-dots-vertical"></i>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    className="btn btn-warning"
                                    href={`/offers/${row.original.id}/edit`}
                                >
                                    <i className="bi bi-pencil-square"></i> Edit
                                </Dropdown.Item>
                               

                                <Dropdown.Divider />
                                <Dropdown.Item as="button" type="button"
                                    className="text-danger"
                                    onClick={() => confirmDelete(row.original.id, row.original.title)}
                                >
                                    <i className="bi bi-trash"></i> Delete
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
            ),
        },
    ];
    const confirmDelete = async (id, title) => {
        await helper.sweetalert
            .confirm(`confirm to delete ${title}`, "warning")
            .then(async (result) => {
                if(result.isConfirmed){
                setShowLoader(true);
                await offersModel.destroy(id).then((res) => {
                    reloadoffersData();
                    helper.sweetalert.toast(`${title} deleted Successfully`);
                });
                setShowLoader(false);
    }});
    };

    return (
        <>
            <Heading title="offers" showLoader={isLoading || showLoader}>
                {console.log()}
                <Link className="btn btn-primary btn-sm" href="/offers/create">
                <i className="bi bi-plus"/>  Create
                </Link>
            </Heading>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">offers Lists</div>
                    <div className="table-responsive">
                        <Table columns={columns} data={offersData?.data || []} />
                    </div>
                    <div className="card-footer">
                        <Pagination meta={offersData?.meta} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
